import React from 'react';
import { color as themeColor } from 'theme';

export const LocationIcon = ({ color }) => (
  <svg
    fill={color || themeColor.red}
    id="Layer_1"
    version="1.1"
    viewBox="0 0 256.17 256.17"
    x="0px"
    xmlns="http://www.w3.org/2000/svg"
    y="0px"
  >
    <g>
      <g>
        <g>
          <path
            d="M254.943,246.737L215.407,98.456c-0.875-3.283-3.849-5.567-7.247-5.567h-29.117c5.652-15.026,8.42-26.05,8.42-33.511
				C187.463,26.637,160.826,0,128.085,0C95.344,0,68.707,26.637,68.707,59.378c0,7.46,2.768,18.486,8.42,33.511H48.01
				c-3.398,0-6.372,2.284-7.247,5.567L1.227,246.737c-1.269,4.757,2.322,9.433,7.247,9.433h239.223
				C252.62,256.17,256.212,251.496,254.943,246.737z M128.085,15c24.47,0,44.378,19.908,44.378,44.378
				c0,21.312-34.5,88.393-44.378,107.16c-9.858-18.73-44.378-85.839-44.378-107.16C83.707,34.908,103.615,15,128.085,15z
				 M121.511,186.05c2.81,5.115,10.259,5.277,13.197-0.091c6.737-12.31,16.84-31.855,24.816-48.418h18.46l18.386,73.967H59.8
				l18.386-73.967h18.459v0C104.556,153.973,115.243,174.642,121.511,186.05z M18.235,241.17l35.537-133.281h29.381
				c2.035,4.802,4.267,9.842,6.46,14.652H72.322c-3.445,0-6.447,2.348-7.278,5.69L42.93,217.198c-1.176,4.732,2.411,9.31,7.278,9.31
				h155.754c4.875,0,8.452-4.585,7.278-9.31l-22.114-88.967c-0.831-3.343-3.833-5.69-7.278-5.69h-17.291
				c2.116-4.642,4.352-9.678,6.46-14.652h29.381l35.537,133.281H18.235z"
          />
          <path
            d="M158.32,59.378c0-16.672-13.563-30.235-30.235-30.235S97.85,42.707,97.85,59.378c0,16.677,13.563,30.245,30.235,30.245
				S158.32,76.055,158.32,59.378z M112.85,59.378c0-8.4,6.834-15.235,15.235-15.235s15.235,6.835,15.235,15.235
				c0,8.406-6.835,15.245-15.235,15.245C119.684,74.623,112.85,67.784,112.85,59.378z"
          />
        </g>
      </g>
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </svg>
);
